/* eslint-disable @typescript-eslint/no-explicit-any */

import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output
} from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { isObservable, Observable } from 'rxjs';
import { ActionMenuOption } from './action-menu.component';

@Component({
  selector: 'man-action-menu-items',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './action-menu-items.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ActionMenuItemsComponent {
  @Input() public options: ActionMenuOption[] = [];
  @Input() public data: any;

  @Output() public optionClick = new EventEmitter<ActionMenuOption>();

  public onClick(option: ActionMenuOption): void {
    if (option.disabled === true) return;
    option.callback?.(this.data);
    this.optionClick.emit(option);
  }

  public isReactiveDisabled(
    disabled: ActionMenuOption['disabled']
  ): disabled is Observable<boolean> {
    return isObservable(disabled);
  }
}
